module.exports = __webpack_public_path__ + "static/img/kk_blue.663f5082.png";